module.exports = __webpack_public_path__ + "img/volume-max-pink.138a38a7.svg";